export default "__VITE_ASSET__mYAYok_D__"